import React, { useEffect, useState } from 'react';
import themeConfig from '@configs/themeConfig';
import { Nav, NavItem, NavLink, Tooltip } from 'reactstrap';
import {
  Bell,
  Calendar,
  Home,
  Layers,
  MessageSquare,
  MoreHorizontal,
  Navigation,
  Settings,
  User,
  Users,
  Zap
} from 'react-feather';
import { PiChalkboardTeacherFill } from 'react-icons/pi';

import { getUserData } from '../../../../utility/Utils';
import { useSkin } from '../../../../utility/hooks/useSkin';
import { useLocation, Link } from 'react-router-dom';
import { FaLayerGroup } from 'react-icons/fa';
import { BiCalendarCheck } from 'react-icons/bi';
import MobileMenu from '../../../../@core/layouts/components/menu/mobile-menu';
export default function BottomMobileNav({organization, themeData}) {
  const { skin } = useSkin();
  const userData = getUserData();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("home");
  const [shortName, setShortName] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => setMenuOpen(!menuOpen);

  const handleMenuClick = (path) => {
    setActiveLink(path);
    setMenuOpen(false);
  }

  const navbarStyle = {
    zIndex: 999,
    padding: '10px',
    borderTop: `1px solid ${skin === 'dark' ? '#2C2C2C' : '#E8E8E8'}`,
    backgroundColor: skin === 'dark' ? '#161D32' : '#F7F7F7',
    height: '80px',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: "nowrap",
    justifyContent: 'space-around',
    alignItems: 'center',
    overflow:"auto hidden"
  };

  const linkStyle = {
    color: skin === 'dark' ? '#FFFFFF' : '#1E1E1E',
    fontSize: '12px',
    fontWeight: 600
  };

  const notActiveLinkStyle = {
    padding: '3px 15px'
  };

  const activeLinkStyle = {
    backgroundColor: ((themeData?.themeColor || '#003fff')) || '#fff',
    fontWeight: 'bolder',
    borderRadius: '15px',
    padding: '3px 15px',
    transition: 'background-color 0.3s ease-in-out',
    color: '#fff'
  };

  const activeTextStyle = {
    color: ((themeData?.themeColor || '#003fff')) || '',
    fontWeight: '600'
  };

  const notActiveTextStyle = {
    color: skin === 'dark' ? '#fff' : '#52544f',
    fontWeight: '600'
  };

  const getActiveStyle = (path) => (activeLink === path ? activeLinkStyle : notActiveLinkStyle);
  const getActiveTextStyle = (path) => (activeLink === path ? activeTextStyle : notActiveTextStyle);

  useEffect(() => {
    if (userData) {
      if (userData?.fullName) {
        const nameOrArr = String(userData?.fullName).split(' ');
        const firstPart = nameOrArr.length > 0 ? nameOrArr[0] : '';
        const lastPart = nameOrArr.length > 1 ? nameOrArr[1] : '';
        setShortName(
          `${firstPart[0].toUpperCase()} ${lastPart[0] ? lastPart[0].toUpperCase() : ''}`
        );
      }
    }
  }, [userData]);


  return (
    <>
        <Nav className="d-flex justify-content-between" style={navbarStyle}>
          <NavItem className="text-center">
            <NavLink
              to="/community/home"
              tag={Link}
              style={linkStyle}
              onClick={() => handleMenuClick('home')}
            >
              <div style={getActiveStyle('home')}>
                <Home size={20} />
              </div>
              <div style={getActiveTextStyle('home')} className="mt-25">
                Home
              </div>
            </NavLink>
          </NavItem>
          <NavItem className="text-center">
            <NavLink
              to="/community/dashboard"
              tag={Link}
              style={linkStyle}
              onClick={() => handleMenuClick('dashboard')}
            >
              <div style={getActiveStyle('dashboard')}>
                <FaLayerGroup size={20} />
              </div>
              <div style={getActiveTextStyle('dashboard')} className="mt-25">
                Feeds
              </div>
            </NavLink>
          </NavItem>
          <NavItem className="text-center">
            <NavLink
              to="/community/events"
              tag={Link}
              style={linkStyle}
              onClick={() => handleMenuClick('events')}
            >
              <div style={getActiveStyle('events')}>
                <Calendar size={20} />
              </div>
              <div style={getActiveTextStyle('events')} className="mt-25">
                Events
              </div>
            </NavLink>
          </NavItem>
          <NavItem className="text-center">
            <NavLink
              to="/community/calendar"
              tag={Link}
              style={linkStyle}
              onClick={() => handleMenuClick('calendar')}
            >
              <div style={getActiveStyle('calendar')}>
                <BiCalendarCheck size={20} />
              </div>
              <div style={getActiveTextStyle('calendar')} className="mt-25">
                Calendar
              </div>
            </NavLink>
          </NavItem>
          <NavItem className="text-center">
            <NavLink style={linkStyle} onClick={() => {
              setActiveLink('menu')
              handleMenuToggle()
            }}>
              <div style={getActiveStyle('menu')}>
                <MoreHorizontal size={20} />
              </div>
              <div style={getActiveTextStyle('menu')} className="mt-25">
                More
              </div>
            </NavLink>
          </NavItem>
        </Nav>
      {menuOpen && (
        <MobileMenu
          open={menuOpen}
          toggle={() => handleMenuToggle()}
        />
      )}
    </>
  );
}
